import React, { useId, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@awesome.me/kit-70c1f0055f/icons/classic/regular";

interface DeveloperMenuSectionProps {
  title: string;
  testId: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  headingIcon?: React.ReactNode;
}

export function DeveloperMenuSection({
  title,
  testId,
  defaultOpen = false,
  children,
  headingIcon,
}: DeveloperMenuSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <section
      className="overflow-hidden rounded-xl bg-slate-800/30 dark:border-slate-600/40"
      data-testid={testId}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left transition-colors hover:bg-slate-700/20"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="flex min-w-0 items-center gap-2 font-mono text-xs uppercase tracking-wide text-gray-500">
          {headingIcon}
          <span className="truncate">{title}</span>
        </span>
        <FontAwesomeIcon
          icon={open ? faChevronDown : faChevronRight}
          className="h-3 w-3 shrink-0 text-slate-500"
          aria-hidden="true"
        />
      </button>
      {open ? (
        <div id={panelId} className="border-t border-slate-700/40 px-4 pb-3 pt-2">
          {children}
        </div>
      ) : null}
    </section>
  );
}
